import { Box, TextField, Typography, Button, Stack } from "@mui/material";
import { Image } from "mui-image";
import { useLazyQuery } from "@apollo/client";
import * as React from "react";
import Snackbar from "../Common/SnackBar";
import { GetBatchTraceItem } from "../../graphql/queries";
import { useOrgDetails } from "../../Hooks/useOrgDetails";
import { useConsumerEngagement } from "../../Hooks/useConsumerEngagement";
import ContentSlider from "../Carousels/ContentSlider";

const ProductView = ({ product_id, org_id }) => {
    const [batchNumber, setBatchNumber] = React.useState("");
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const { consumerEngagementDetails, loading, isExpired } = useConsumerEngagement({ orgId: org_id, productId: product_id });

    const { orgInfo, lotBatchLabel, lotBatchLabelDesc } = useOrgDetails(org_id, product_id);

    // Get Lot/Batch info
    const [getBatchTraceItem, { loading: batchLoading }] = useLazyQuery(GetBatchTraceItem, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            const traceItemId = data?.getBatchTraceItem?.traceItemId;
            if (traceItemId) {
                const newUrl = `${window.location.origin}?trace_item_id=${traceItemId}`;
                window.location.href = newUrl;
            } else {
                setSnackbarOpen(true);

            }
        },
    });

    // Submit after user enter lot/batch id
    const handleSubmit = () => {
        getBatchTraceItem({
            variables: {
                filters: {
                    orgId: org_id,
                    productId: product_id,
                    lotBatchId: batchNumber
                },
            },
        });
    };

    return (
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Stack direction="column" justifyContent="center" alignItems="center"
                sx={{ height: { sm: "150px", md: "175px", lg: "250px" }, }}>
                {<Image
                    src={orgInfo?.bannerPresignedUrl}
                    alt="banner"
                    sx={{
                        objectFit: "contain",
                        width: "100%",
                        height: { sm: "150px", md: "175px", lg: "250px" },
                    }}
                />
                }
            </Stack>
            {orgInfo &&
                <Box
                    maxWidth={{ xs: "100%", md: "800px" }}
                    id="org-info"
                    sx={{
                        py: 1, px: 1, backgroundColor: "#FFFFFF",
                        borderRadius: "8px", boxShadow: 3, mt: 2,
                        alignItems: "center",
                    }}
                >
                    <ContentSlider orgInfo={orgInfo}
                        customerScanDetails={consumerEngagementDetails}
                        isExpired={isExpired}
                        loading={loading} />
                </Box>
            }
            <Stack
                width={{ xs: "100%", md: "400px" }}
                id="org-info"
            >
                <TextField
                    label={lotBatchLabel || "Lot Batch ID"}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={batchNumber}
                    onChange={(e) => setBatchNumber(e.target.value)}
                />
                <Typography variant="caption" color="gray" px={1}>
                    {lotBatchLabelDesc}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2, mx: 8 }}
                    disabled={!batchNumber.trim() || batchLoading}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>
            </Stack>
            <Snackbar
                open={snackbarOpen}
                onClose={() => setSnackbarOpen(false)}
                message="Lot batch Id is not valid, please recheck"
                severity="error"
            />
        </Box>
    )
}

export default ProductView;